import type { ReactElement } from 'react';
import { Route, BrowserRouter, Switch, Redirect } from 'react-router-dom';

import {
  Login,
  Error,
  Register,
  GuarantorsForm,
  RegisterGuarantors,
  WaitAnalysis,
  Approval,
  RedirectEducation,
  Disapproval,
  Home,
  Instruction,
  NoAccess,
} from '@/pages/index';
import RequireAuth from './RequireAuth';
import ScrollToTop from '@/components/organisms/scrollToTop';
import Balance from '@/pages/balance/Balance';

const Routes = (): ReactElement => {
  return (
    <BrowserRouter>
      <Switch>
        <Route component={Login} path="/" exact />
        <Route component={Home} path="/callback" exact />

        <Route path="/register" exact>
          <RequireAuth>
            <>
              <ScrollToTop />
              <Register />
            </>
          </RequireAuth>
        </Route>

        <Route path="/register/guarantors" exact>
          <RequireAuth>
            <RegisterGuarantors />
          </RequireAuth>
        </Route>

        <Route path="/register/first-person-guarantor" exact>
          <RequireAuth>
            <>
              <ScrollToTop />
              <GuarantorsForm />
            </>
          </RequireAuth>
        </Route>

        <Route path="/register/second-person-guarantor" exact>
          <RequireAuth>
            <>
              <ScrollToTop />
              <GuarantorsForm />
            </>
          </RequireAuth>
        </Route>

        <Route path="/register/guarantor-form" exact>
          <RequireAuth>
            <>
              <ScrollToTop />
              <GuarantorsForm />
            </>
          </RequireAuth>
        </Route>

        <Route path="/register/approval" exact>
          <RequireAuth>
            <Approval />
          </RequireAuth>
        </Route>

        <Route path="/register/wait-analysis" exact>
          <RequireAuth>
            <WaitAnalysis />
          </RequireAuth>
        </Route>
        <Route path="/register/disapproval" exact>
          <RequireAuth>
            <Disapproval />
          </RequireAuth>
        </Route>

        <Route path="/instructions" exact>
          <RequireAuth>
            <Instruction />
          </RequireAuth>
        </Route>

        <Route path="/payment-history" exact>
          <RequireAuth>
            <Balance />
          </RequireAuth>
        </Route>

        <Route path="/no-access" exact>
          <RequireAuth>
            <NoAccess />
          </RequireAuth>
        </Route>

        <Route component={RedirectEducation} path="/redirect-education" exact />
        <Route component={RedirectEducation} path="/forgot-password" exact />

        <Route component={Error} path="/error" />
        <Redirect to="/error" />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
